
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/KoiFish-Cafe",
      function () {
        return require("private-next-pages/KoiFish-Cafe/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/KoiFish-Cafe"])
      });
    }
  